export function getPdxIfuHref(language) {
  const lang = String(language || "en-GB").toLowerCase();
  return `https://www.electronrx.com/instructions-for-use-pdx1-${lang}`;
}
